import styled from "styled-components";

export const ResetWrapper = styled.div`
width: 100%;
height: auto;
display: flex;
align-items: center;
justify-content: center;
`

export const ResetBtn = styled.button`
padding: 16px;
background-color: #f3f4f4;
cursor: pointer;
border-radius 10%;

&:hover {
    box-shadow: inset 0px 0px 2px #000;
}
`